type ApiErrorBody = {
  status?: string;
  error?: {
    code?: string;
    message?: string;
    details?: string;
    statusCode?: number;
    domain?: string;
  };
  message?: string | string[];
  statusCode?: number;
};

export function readApiError(error: unknown): {
  code?: string;
  message?: string;
  details?: string;
  statusCode?: number;
} {
  const err = error as {
    status?: number | string;
    data?: ApiErrorBody;
    response?: { data?: ApiErrorBody; status?: number };
  };

  const data = err?.data ?? err?.response?.data;
  const nested = data?.error;
  const rawMessage = nested?.message || data?.message;
  const message = Array.isArray(rawMessage) ? rawMessage.join('. ') : rawMessage;

  return {
    code: nested?.code,
    message,
    details: nested?.details,
    statusCode:
      nested?.statusCode ??
      data?.statusCode ??
      (typeof err.status === 'number' ? err.status : undefined) ??
      err.response?.status,
  };
}
